import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

/**
 * A reusable confirmation dialog component.
 * 
 * @param {boolean} open - Whether the dialog is open
 * @param {string} title - Dialog title
 * @param {string|React.ReactNode} message - Confirmation message
 * @param {string} confirmText - Text for confirm button (default: "Yes")
 * @param {string} cancelText - Text for cancel button (default: "No")
 * @param {string} confirmColor - Color for confirm button (default: "error")
 * @param {function} onConfirm - Callback when user confirms
 * @param {function} onCancel - Callback when user cancels
 * @param {boolean} loading - Whether the action is in progress
 */
export default function ConfirmationDialog({
    open,
    title = "Confirm Action",
    message,
    confirmText = "Yes",
    cancelText = "No",
    confirmColor = "error",
    onConfirm,
    onCancel,
    loading = false,
}) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onCancel} 
                    disabled={loading}
                    color="inherit"
                >
                    {cancelText}
                </Button>
                <Button 
                    onClick={onConfirm} 
                    color={confirmColor}
                    variant="contained"
                    disabled={loading}
                    autoFocus
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
